import EventEmitter from 'eventemitter3';
import i18nextGlobal from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import $ from 'jquery';
import jqueryI18next from 'jquery-i18next';

import { getDefaultUiLocale } from './js_data';

function createDefaultLanguage(lng) {
    return {
        name: 'defaultLanguage',
        lookup(options) {
            return lng;
        },
        cacheUserLanguage() {
        },
    };
}

let i18next;
let t;
let i18nextEvents;
const SUPPORTED_LNGS = ['it', 'en'];

function initJquery() {
    jqueryI18next.init(i18next, $, {
    });
    $('body').localize();
    i18nextEvents.on('languageChanged', () => {
        $('body').localize();
    });
}

function createI18next(defaultLanguage) {
    const languageDetector = new LanguageDetector();
    if(defaultLanguage) {
        languageDetector.addDetector(createDefaultLanguage(defaultLanguage));
    }
    languageDetector.init(null, {
        order: [].concat(['localStorage'], defaultLanguage ? ['defaultLanguage'] : [], ['querystring', 'navigator']),
        caches: ['localStorage'],
        lookupQuerystring: 'lng',
        lookupLocalStorage: 'i18nextLngDscloud',
    });

    const cache = new Map();
    return i18nextGlobal
        .use(languageDetector)
        .use({
            type: 'backend',
            read(
                language,
                namespace,
                callback,
            ) {
                Promise.resolve()
                    .then(() => {
                        const cached = cache.get(language);
                        if(cached) {
                            return Promise.resolve(cached);
                        }
                        switch(language) {
                            case 'en':
                                return import('../data-i18n/en.js');
                        }
                        return import('../data-i18n/it.js');
                    })
                    .then((resources) => {
                        const locale = resources.default;
                        cache.set(language, locale);
                        callback(null, locale[namespace]);
                    })
                    .catch((error) => {
                        callback(error, null);
                    });
            },
        })
        .init({
            supportedLngs: SUPPORTED_LNGS,
        })
        .then((_t) => {
            i18next = i18nextGlobal;
            t = _t;
            i18nextEvents = new EventEmitter();
            initJquery();
        });
}

export function createLocalization(defaultLanguage) {
    return createI18next(defaultLanguage ?? getDefaultUiLocale())
        .then(() => ({ i18next, i18nextEvents }));
}

export function usingLocalization(_i18next, _i18nextEvents) {
    i18next = _i18next;
    t = i18next.t.bind(i18next);
    i18nextEvents = _i18nextEvents;
    initJquery();
}

export function getTranslator() {
    if(!t) {
        return (...args) => t?.(...args) ?? String(args[0] ?? '');
    }
    return t;
}

function populateLocaleSelect($select) {
    const currentLng = i18next.language;
    $select.empty();
    SUPPORTED_LNGS.forEach((lng) => {
        const label = lng.toUpperCase();
        $select.append($('<option>', {
            value: lng,
            text: label,
        }));
    });
    $select.val(currentLng);
}

export function setupLocaleSwitcher(selector) {
    const sel = selector || '#locales';

    const $select = $(sel);
    if(!$select.length) {
        return;
    }
    populateLocaleSelect($select, i18next);
    $select.off('change.localeSwitcher').on('change.localeSwitcher', function changeHandler() {
        const newLng = this.value;
        i18next.changeLanguage(newLng, () => {
            document.documentElement.lang = newLng;
            i18nextEvents.emit('languageChanged');
        });
    });
}
